import React from "react";

/**
 * Full-screen SSO failure screen. Shown by SsoCallback whenever the backend
 * redirects to /sso-callback with an ?sso_error=<message> parameter (any SSO
 * failure: unauthorized user, signature/assertion errors, provisioning errors,
 * expired token, etc.).
 */
const SsoError = ({ message, onBackToLogin }) => {
  const displayMessage =
    (message && String(message).trim()) ||
    "We couldn't sign you in. Please try again or contact your administrator.";

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fd6a60"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>

        <h1 style={styles.title}>Sign-in failed</h1>
        <p style={styles.message}>{displayMessage}</p>

        <button type="button" style={styles.button} onClick={onBackToLogin}>
          Back to Login
        </button>

        <p style={styles.help}>
          If this keeps happening, please contact your administrator.
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    position: "fixed",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f4f6f9",
    padding: "20px",
    zIndex: 9999,
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    padding: "40px 32px",
    textAlign: "center",
    fontFamily: "'Roboto', 'Segoe UI', Arial, sans-serif",
  },
  iconWrap: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    background: "rgba(253,106,96,0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#2b2b2b",
    margin: "0 0 10px",
  },
  message: {
    fontSize: "15px",
    lineHeight: 1.5,
    color: "#6b7280",
    margin: "0 0 28px",
  },
  button: {
    display: "inline-block",
    width: "100%",
    padding: "12px 20px",
    fontSize: "15px",
    fontWeight: 600,
    color: "#ffffff",
    background: "#fd6a60",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
  help: {
    fontSize: "12.5px",
    color: "#9aa0a6",
    margin: "18px 0 0",
  },
};

export default SsoError;
